import { inr } from './design/atoms';

/* Plan presentation shared by the browse-only plans page and the store. */

const PLAN_TYPE_LABELS: Record<string, string> = {
  standard: 'Standard',
  pay_as_you_go: 'Pay as you go',
  entry_based: 'Entry passes',
  hourly: 'Hourly',
  family: 'Family',
  group: 'Group',
  corporate: 'Corporate',
  seasonal: 'Seasonal',
  goal_specific: 'Goal programme',
};

/** The features blob → short readable chips. Unknown keys are ignored. */
export function featureChips(features: Record<string, any> | null): string[] {
  if (!features) return [];
  const chips: string[] = [];
  if (features.planType && features.planType !== 'standard') {
    chips.push(PLAN_TYPE_LABELS[features.planType] ?? features.planType);
  }
  if (features.timeRestrictions?.offPeakOnly) chips.push('Off-peak hours');
  if (features.pauseEnabled) {
    const days = features.pauseRules?.maxTotalDays;
    chips.push(days ? `Pause up to ${days} days` : 'Pausable');
  }
  if (features.guestPasses?.enabled) {
    const n = features.guestPasses?.count ?? features.guestPasses?.total;
    chips.push(n ? `${n} guest pass${n === 1 ? '' : 'es'}` : 'Guest passes');
  }
  if (features.externalGymAccess?.enabled) {
    const days = features.externalGymAccess?.days;
    chips.push(days ? `Partner gyms · ${days} days` : 'Partner gym access');
  }
  if (features.maxUsers && features.maxUsers > 1) chips.push(`Up to ${features.maxUsers} people`);
  if (features.loyaltyPoints?.enabled) chips.push('Loyalty points');
  if (features.entryBased?.entryPrice) chips.push(`${inr(features.entryBased.entryPrice)} per entry`);
  if (features.hourlyBased?.hourlyRate) chips.push(`${inr(features.hourlyBased.hourlyRate)} per hour`);
  return chips;
}

export function durationLabel(months: number | null): string | null {
  if (!months) return null;
  if (months === 1) return '1 month';
  if (months % 12 === 0) return `${months / 12} year${months === 12 ? '' : 's'}`;
  return `${months} months`;
}

